<template>
  <w-modal
    v-model="show"
    :title="$t('modals.players-account')"
    :close-button="$t('buttons.cancel')"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    :submit-button="$t('buttons.create')"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-md-12">
        <w-input :model="$schema.email" :title="$t($schema.email.$schema.title)" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/account.schema';
import { tryParseInt } from '@/utils/number';

const emptyData = () => ({ email: '', profileId: null, teamId: null });

// @vuese
// Modal tworzenia konta
// @group Team
export default {
  mixins: [manageMixin('team', {}, emptyData)],
  props: {
    // Identyfikator profilu
    profileId: {
      type: Number,
      required: false
    }
  },
  methods: {
    // @vuese
    // Funkcja waliduje formularz
    save() {
      this.$schema.$setData({
        profileId: this.profileId,
        teamId: tryParseInt(this.$route.params.teamId)
      });

      if (!this.$schema.$validateAll().length) {
        this.$emit('save', this.model);
        this.close();
      } else {
        this.notifyError('messages.form.error');
      }
    }
  },
  schema
};
</script>
